import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify);

/**
 * Predefined colours are found here: https://vuetifyjs.com/en/style/colors
 */

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#003865", // this is used for more than just buttons (eg highlighting of input elements) - be careful when changing
                accent: "#B079B3",
                navigation: colors.grey.lighten2,
                success: "#61B6AB",
                error: "#E50152",
                warning: "#F39F52",
                info: "#61C2D9" // this is used for more than just buttons - be careful when changing
            },
            dark: {
                primary: "#003865", // this is used for more than just buttons (eg highlighting of input elements) - be careful when changing
                accent: "#B079B3",
                navigation: colors.grey.lighten2,
                success: "#61B6AB",
                error: "#E50152",
                warning: "#F39F52",
                info: "#61C2D9" // this is used for more than just buttons - be careful when changing
            }
        },
        options: {
            customProperties: true
        }
    }
});